import Cookies from "js-cookie";

const TRACKING_ENDPOINT =
  "https://www.smart-lend.com/api/user-product-interests";

export const createTrackingId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getDeviceType = (isMobile) =>
  isMobile ? "mobile" : "desktop_tablet";

export const trackUserProductInterest = async ({
  trackingId,
  productPage,
  deviceType,
  enteredLoanAmount = false,
  enteredInterestRate = false,
  enteredTenor = false,
  loanAmount = null,
}) => {
  if (!trackingId || !productPage || !deviceType) {
    return;
  }

  const token = Cookies.get("token");
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  const payload = {
    tracking_id: trackingId,
    product_page: productPage,
    device_type: deviceType,
    entered_loan_amount: enteredLoanAmount,
    entered_interest_rate: enteredInterestRate,
    entered_tenor: enteredTenor,
    loan_amount: loanAmount,
  };

  try {
    await fetch(TRACKING_ENDPOINT, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error("Failed to track product interest", error);
  }
};
